/* eslint-disable react/display-name */
import React from 'react';
import config from './pages-config';
import {
    AboutUsPage,
    HomePage,
    SportPage,
    SlotsCasinos,
    SlotsBattles,
    PromoPage,
    ForgotPassword,
    ResetPassword,
    ChangePassword,
    MyAccountPage,
    BetOnGames,
    Twain,
    LiveGames,
    Lottery,
    TvBet,
    ErrorPage,
    ContactUsPage,
    MailVerifyPage,
    Lobby,
    RacebookPage,
    Zoom,
} from './../../pages';

const basePagesConfig = {
    homePage: {
        name: 'Homepage',
        Component: (props) => <HomePage {...props} />,
        url: '/',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    signUpPage: {
        name: 'Signup',
        Component: (props) => <HomePage {...props} />,
        url: '/signup',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    livePage: {
        name: 'Live',
        Component: (props) => <SportPage {...props} />,
        url: '/sport/live/:sportId?/:categoryId?/:tournamentId?/:matchId?',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    sportPage: {
        name: 'Prematch',
        Component: (props) => <SportPage {...props} />,
        url: '/sport/:branchId?/:sportId?/:categoryId?/:tournamentId?/:matchId?/:matchQueryParam?',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    casinosPage: {
        name: 'Casino',
        Component: (props) => <SlotsCasinos {...props} gamesType="casino" />,
        url: '/casino/:viewType?',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    slotsPage: {
        name: 'Slots',
        Component: (props) => <SlotsCasinos {...props} gamesType="slots" />,
        url: '/slots/:viewType?/:jackpotId?',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    slotsBattlePage: {
        name: 'SlotsBattle',
        Component: (props) => <SlotsBattles {...props} />,
        url: '/slots-battles/:gameId?',
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    liveCasinoPage: {
        name: 'LiveSlots',
        Component: (props) => <Zoom {...props} />,
        url: '/live-slots',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    racebookPage: {
        name: 'Racebook',
        Component: (props) => <RacebookPage {...props} />,
        url: '/racebook',
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    forgotPassword: {
        name: 'Forgot Password',
        Component: (props) => <ForgotPassword {...props} />,
        url: '/forgot-password',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet'],
        logoutRequired: true,
    },
    resetPassword: {
        name: 'Reset Password',
        Component: (props) => <ResetPassword {...props} />,
        url: '/passwordreset',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
        logoutRequired: true,
    },
    changePassword: {
        name: 'Change password',
        Component: (props) => <ChangePassword {...props} />,
        url: '/change-password',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet'],
        loginRequired: true,
    },
    promoPage: {
        name: 'Promopage',
        Component: (props) => <PromoPage {...props} />,
        url: '/promo',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    aboutUsPage: {
        name: 'About Us',
        Component: (props) => <AboutUsPage {...props} />,
        url: '/aboutus',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    myAccountPage: {
        name: 'My account',
        Component: (props) => <MyAccountPage {...props} />,
        url: '/account',
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
        loginRequired: true,
        allowedForBlocked: true,
    },
    betOnGames: {
        name: 'Bet Games',
        Component: (props) => <BetOnGames {...props} />,
        url: '/bet-games',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    twain: {
        name: 'Twain',
        Component: (props) => <Twain {...props} />,
        url: '/twain',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    liveGames: {
        name: 'Live games',
        Component: (props) => <LiveGames {...props} />,
        url: '/live-games',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    lottery: {
        name: 'Lottery',
        Component: (props) => <Lottery {...props} />,
        url: '/lottery',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    tvbet: {
        name: 'TVBET',
        Component: (props) => <TvBet {...props} />,
        url: '/tvbet',
        exact: true,
        loginRequired: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    helpPage: {
        name: 'Contact Us',
        Component: (props) => <ContactUsPage {...props} />,
        url: '/contact-us',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    mailVerify: {
        name: 'Mail Verify',
        Component: (props) => <MailVerifyPage {...props} />,
        url: '/mailverify',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
    },
    lobbyPage: {
        name: 'Lobby',
        Component: (props) => <Lobby {...props} />,
        url: '/lobby',
        exact: true,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
        loginRequired: true,
    },
};

const pagesConfig = () => {
    const newConfig = {};
    Object.keys(config).forEach(key => newConfig[key] = Object.assign(config[key], basePagesConfig[key]));
    newConfig.error404Page = {
        name: 'Error',
        Component: (props) => <ErrorPage {...props} />,
        allowedViewSizes: ['mobile', 'tablet', 'desktop'],
        meta: {
            title: '404',
            description: '',
            keywords: '',
        },
    };
    return newConfig;
};

export default pagesConfig;
